import React from "react";

interface IsaacNumberInputProps {
  newValue: number;
  handleValueChanged: (value: number) => void;
  handleBlur: () => void;
}

const IsaacNumberInput: React.FunctionComponent<IsaacNumberInputProps> = ({
  newValue,
  handleValueChanged,
  handleBlur,
}) => {
  return (
    <input
      value={newValue ?? 0}
      type="number"
      onBlur={handleBlur}
      onChange={e => {
        handleValueChanged(Number(e.target.value));
      }}
    />
  );
};

export default IsaacNumberInput;
